module.exports = __webpack_public_path__ + "assets/images/50L-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/50L-route-sheet.png
// module id = 1304
// module chunks = 1